export default {
  daysBetween(date1, date2) {
    if (!date1 || !date2) {
      return 0
    }

    const dates = [date1, date2]
    const maxDate = new Date(Math.max.apply(null, dates))
    const minDate = new Date(Math.min.apply(null, dates))

    // reset the days to midnight
    maxDate.setHours(0, 0, 0, 0)
    minDate.setHours(0, 0, 0, 0)
    const differenceInTime = maxDate.getTime() - minDate.getTime()
    const differenceInDays = differenceInTime / (1000 * 3600 * 24)

    // console.log({ date1, date2, diff: differenceInDays })
    return differenceInDays
  },
  toISODateString(date) {
    if (!date) {
      return
    }

    if (!(date instanceof Date)) {
      date = new Date(date)
    }

    return date.toISOString().slice(0, 10)
  },
  toLongDateFormat(epoch, region) {
    if (!epoch) return

    const date = new Date(epoch * 1000)

    const formatOptions = {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }

    return date.toLocaleDateString(region, formatOptions)
  },
  dateTime(epoch, region) {
    if (!epoch) {
      return ''
    }
    const dateValue = new Date(epoch)
    let hourPart = 'u'
    if (region !== 'nl-BE') {
      hourPart = 'h'
    }
    const timePart = `${dateValue.getHours()}${hourPart}${`${dateValue.getMinutes()}`.padStart(
      2,
      '0'
    )}`
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }
    const dateFormat = dateValue.toLocaleDateString(region || 'nl-BE', options)
    return `${dateFormat} - ${timePart}`
  },
  dateOnly(epoch, region) {
    if (!epoch) {
      return ''
    }

    epoch = epoch * 1000

    const dateValue = new Date(epoch)
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }
    const dateFormat = dateValue.toLocaleDateString(region || 'nl-BE', options)
    return dateFormat
  },
  getCurrentYear() {
    const dateValue = new Date()
    return dateValue.getFullYear()
  },
  getCurrentMonth() {
    const dateValue = new Date()
    return dateValue.getMonth() + 1
  },
  getCurrentMonthToString(region) {
    const dateValue = new Date()
    return dateValue.toLocaleString(region || 'nl-BE', { month: 'long' })
  },
  getCurrentDay() {
    const dateValue = new Date()
    return dateValue.getDate()
  },
  getCurrentLastDayOfMonth() {
    const dateValue = new Date()
    const lastDay = new Date(
      dateValue.getFullYear(),
      dateValue.getMonth() + 1,
      0
    )
    return lastDay.getDate()
  },
  getDaysInCurrentMonth() {
    return new Date(this.getCurrentYear(), this.getCurrentMonth(), 0).getDate()
  },
  timeDecimalToStringNotation(time, region) {
    if (!time && time !== 0) {
      return ''
    }
    time = time.toFixed(2) // Always start with 2 decimals to calculate the time strings
    let hourPart = 'u'
    if (region !== 'nl-BE') {
      hourPart = 'h'
    }
    const timeStrings = time.toString().split('.')
    const hourString = timeStrings[0]
    let minutesString = '00'
    if (timeStrings.length > 1 && parseInt(timeStrings[1]) > 0) {
      minutesString = ((parseInt(timeStrings[1]) / 100) * 60).toString()
    }
    return `${hourString}${hourPart}${minutesString}`
  }
}
